import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { db } from "@/lib/db";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Check, ArrowLeft, Loader2, CreditCard } from "lucide-react";
import { toast } from "sonner";

const PLANS = {
  basico: { name: "Básico", price: "29", features: ["Calculadora inteligente", "Até 10 propostas/mês", "CRM básico (50 leads)", "Suporte por e-mail"] },
  pro: { name: "Pro", price: "79", features: ["Tudo do Básico", "Propostas com IA ilimitadas", "Gestão de projetos + financeiro", "Scripts comerciais com IA", "Leads ilimitados"] },
  premium: { name: "Premium", price: "149", features: ["Tudo do Pro", "Templates avançados", "Relatórios detalhados", "Suporte prioritário", "Consultoria mensal 1:1"] },
};

export default function Checkout() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  
  const planKey = params.get("plan") || "pro";
  const plan = PLANS[planKey] || PLANS.pro;

  const handlePayment = () => {
    if (!user || !user.id) {
      toast.error("Erro: Usuário não identificado. Tente fazer login novamente.");
      return;
    }

    setLoading(true);
    console.log("Iniciando pagamento para:", user.id, "Plano:", planKey);
    
    const planUrls = {
      basico: "https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=0f13ec71bad849c29547d5efb49c6704",
      pro: "https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=44a4e3d44ab147f582d2eb0091e97c96",
      premium: "https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=848265d61f1d47cea5d63eb8a0831840"
    };

    const baseUrl = planUrls[planKey];
    
    if (baseUrl) {
      // Usamos apenas o link limpo, pois o MP não aceita parâmetros extras aqui
      window.location.href = baseUrl;
    } else {
      toast.error("Plano não encontrado.");
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto py-12 px-6">
      <Link to="/app/dashboard" className="flex items-center gap-2 text-sm text-[#8A8A8A] hover:text-black mb-8 transition-colors">
        <ArrowLeft className="w-4 h-4" />
        Voltar ao painel
      </Link>

      <h1 className="font-serif text-4xl mb-2">Finalizar Assinatura</h1>
      <p className="text-[#4A4A4A] mb-10 text-lg">Você está a um passo de profissionalizar sua revisão.</p>

      <div className="grid md:grid-cols-1 gap-8">
        <Card className="p-8 bg-white border border-black/10 rounded-none shadow-editorial">
          <div className="flex justify-between items-start mb-6">
            <div>
              <div className="font-mono text-xs uppercase tracking-widest text-[#D9381E] mb-1">Plano Selecionado</div>
              <h2 className="font-serif text-3xl">{plan.name}</h2>
            </div>
            <div className="text-right">
              <div className="font-serif text-4xl font-semibold">R$ {plan.price}</div>
              <div className="font-mono text-xs text-[#8A8A8A]">POR MÊS</div>
            </div>
          </div>

          <div className="space-y-4 mb-10">
            <div className="text-xs font-mono uppercase tracking-widest text-[#8A8A8A] border-b border-black/5 pb-2">O que está incluso:</div>
            <ul className="space-y-3">
              {plan.features.map((f, i) => (
                <li key={i} className="flex items-start gap-3 text-sm">
                  <Check className="w-4 h-4 mt-0.5 text-[#D9381E] shrink-0" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>

          <Button 
            onClick={handlePayment} 
            disabled={loading}
            className="w-full bg-[#D9381E] hover:bg-[#B82914] text-white rounded-none py-8 text-lg font-medium flex items-center justify-center gap-3"
          >
            {loading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              <>
                <CreditCard className="w-5 h-5" />
                Pagar com Mercado Pago
              </>
            )}
          </Button>

          <p className="mt-6 text-center text-xs text-[#8A8A8A] font-mono">
            Pagamento processado de forma segura pelo Mercado Pago. <br/>
            Cancele quando quiser. Sem fidelidade.
          </p>
        </Card>
      </div>
    </div>
  );
}
